module.exports = __webpack_public_path__ + "static/media/BrightEyes.954f4af6.jpeg";